export const useCaseMap = {
  None: 'None',
  AddVehicleWorkingTime: 36,
  DeleteVehicleWorkingTime: 39,
  SearchVehicleWorkingTime: 37,
  UpdateVehicleWorkingTime: 38,
  AddVehicleType: 11,
  DeleteVehicleType: 14,
  SearchVehicleType: 12,
  UpdateVehicleType: 13,
  AddVehicle: 56,
  DeleteVehicle: 59,
  SearchVehicles: 57,
  UpdateVehicle: 58,
  AddVehicleGroup: 21,
  SearchVehicleGroup: 22,
  UpdateVehicleGroup: 23,
  DeleteVehicleGroup: 24,
  RoleSearch: 2,
  UpdateRole: 3,
  AddNonWorkingDay: 46,
  Deletenonworkingday: 49,
  SearchNonWorkingdays: 47,
  Updatenonworkingday: 48,
  AddManufacturer: 51,
  DeleteManufacturer: 54,
  SearchManufacturers: 52,
  UpdateManufacturer: 53,
  AddingIncidentType: 26,
  DeleteIncidenttype: 27,
  FindIncidentType: 28,
  SearchIncidentType: 29,
  UpdateIncidentType: 30,
  AddIcon: 16,
  DeleteIcon: 19,
  SearchIcon: 17,
  UpdateIcon: 18,
  AddIButton: 31,
  DeleteIButton: 34,
  SearchIButton: 32,
  UpdateIButton: 33,
  UpdateAlarm: 43,
  Alarmsearch: 42,
  AddAlarm: 41,
  DeleteAlarm: 44,
  SearchModems: 62,
  AddModem: 61,
  DeleteModem: 64,
  UpdateModem: 63,
  UpdateModemType: 28,
  AddModemType: 26,
  DeleteModemType: 29,
  SearchModemType: 27,
  DriverSearch: 84,
  WorkingHoursSearch: 0,
  BulkImportSearch: 0,
  AuditSearch: 200,
  Adddigitalinputdevice: 72,
  Searchdigitalinputdevices: 73,
  DeleteDigitalInputdevice: 75,
  UpdateDigitalDevice: 74,
  FindCompanySettings: 70,
  UpdateCompanySettings: 71,
  BulkImportNonWorkingDays: 100,
  BulkImportDrivers: 99,
  BulkImportRefuel: 101,
  AddVehicleRefuel: 94,
  SearchVehicleRefuel: 95,
  UpdateVehicleRefuel: 96,
  DeleteVehicleRefuel: 97,
  SearchUsers: 102,
  UpdateUser: 111,
  AddDriver: 83,
  Searchdrivers: 84,
  UpdateDriver: 85,
  DeleteDriver: 86,
  AddCurrency: 104,
  SearchCurrencies: 105,
  UpdateCurrency: 106,
  DeleteCurrency: 107,
  AddPoi: 66,
  SearchPoi: 67,
  UpdatePoi: 68,
  DeletePoi: 69,
  VehicleLocationReport: 77,
  TelemetryReport: 78,
  NonWorkingDaysVehicleUsageReport: 79,
  TravelHistoryReport: 80,
  VehicleUsageReport: 81,
  TotalCovereddistance: 82,
  Statisticsreportexport: 88,
  RetroactiveVehiclePoiPassageReport: 89,
  SpeedingSummary: 90,
  SpeedingReport: 91,
  BorderCrossReport: 92,
  Incidentreport: 93,
  AlarmReport: 103,
  SpecializedStatistics: 122,
  SearchDriverprofilereports: 109,
  VehicleUsageReportByDriver: 112,
  StatisticsReportbydriver: 113,
  RefuelReport: 133,
  FuelDropReport: 149,
  Statisticssummaryreportexport: 115,
  SearchDevicestatusreports: 116,
  Driverrecordreportexport: 117,
  ConditionalTravelhistoryreport: 118,
  AddServiceBookPlanning: 119,
  TooLongHoldInPoiReport: 150,
  TemperatureReport: 151,
  TotalSpentAmountReport: 152,
  IOStatusChangeReport: 153,
  IOStatusChangeSummary: 154,
  EveryPackageReport: 155,
  PrivateBusinessDrive: 156,
  AnomalyReport: 157,
  DriverLocationReport: 158,
  RawAvlData: 165,
  SearchServiceBookPlanning: 120,
  UpdateServiceBookPlanning: 121,
  DeleteServiceBookPlanning: 123,
  SearchServiceBookContacts: 128,
  UpdateServiceBookContact: 130,
  AddServiceBookContact: 131,
  DeleteServiceBookContact: 132,
  SearchScheduledReports: 135,
  FindScheduledReport: 135,
  AddScheduledReport: 134,
  UpdateScheduledReport: 136,
  DeleteScheduledReport: 137,
  SearchNotifications: 145,
  FindNotification: 147,
  AddNotification: 144,
  UpdateNotification: 145,
  DeleteNotification: 148,
  AddServiceRealization: 124,
  SearchServiceRealization: 125,
  UpdateServiceRealization: 126,
  DeleteServiceRealization: 127,
  GraphReportUseCase: 114,
  AddUser: 98,
  UserSearch: 102,
  DeleteUser: 138,
  AddTenantSettings: 65,
  TenantSettingsSearch: 70,
  UpdateTenantSettings: 71,
  DeleteTenantSettings: 140,
  SuperAdminSearch: 142,
  UpdateSuperAdmin: 143,
  AddSuperAdmin: 141,
  DeleteSuperAdmin: 147,
  AddRole: 1,
  DeleteRole: 4,
  SaveRouteOptimization: 40,
  SearchRouteOptimizations: 167,
  UpdateRouteOptimization: 168,
  DeleteRouteOptimization: 169,
  AllVehiclesReport: 176,
  FindProbeCalibration: 175,
  AddProbeCalibration: 171,
  MonthlyUsedVehiclesReport: 177,
  TotalCoveredDistanceSummary: 282,
  NonWorkingDaysVehicleUsageReportSummary: 279,
  PrivateBusinessDriveReportSummary: 256,
  AddTimocomAccount: 285,
  DeleteTimocomAccount: 286,
  SearchTimocomAccount: 287,
  UpdateTimocomAccount: 288,
  FindTimocomAccount: 289,
  AnalysisBusinessDriveReport: 210,
  AnalysisBusinessDriveByDriverReport: 159,
  IButtonBulkImport: 292,
  DetachIButtonFromDriverUseCase: 293,
  DetachVehicleFromDriverUseCase: 294,
  AddPoiGroupUseCase: 251,
  DeletePoiGroupUseCase: 255,
  FindPoiGroupUseCase: 253,
  SearchPoiGroupsUseCase: 252,
  UpdatePoiGroupUseCase: 254,
  AddDriverGroup: 300,
  DeleteDriverGroup: 301,
  UpdateDriverGroup: 302,
  SearchDriverGroups: 303,
  DeltaCustomMonthlyCalculation: 304,
  AnalysisBusinessDriveByDriverReportV2: 305,
  AddMileageReset: 297,
  UpdateMileageReset: 298,
  DeleteMileageReset: 299,
  SearchMileageReset: 295,
  PoisBulkImportUseCase: 306,
  PrivateBusinessDriveByWorkingHours: 307,
  DownloadPrivateBusinessDriveByWorkingHours: 309,
  GeneraliTravelHistoryReport: 313,
  AnalysisPrivateDriveReport: 314,
  PoiPassagesMultiplePois: 315,
  AddPoiObjectType: 316,
  SearchPoiObjectType: 317,
  FindPoiObjectType: 318,
  UpdatePoiObjectType: 319,
  DeletePoiObjectType: 320,
  TankCapReportUseCase: 312,
  EngineBlockageRequests: 311,
  SyncPosUseCase: 321,
  GetModifiedPosUseCase: 322,
  TemperatureIoConjoinedReportUseCase: 323,
  MileageCleanupUseCase: 324,
  PrivateBusinessDriveTransitionsReportUseCase: 325,
  DigitalTachographReportUseCase: 340,
  AddTenantFuelTypeUseCase: 341,
  SearchTenantFuelTypesUseCase: 342,
  FindTenantFuelTypeUseCase: 343,
  UpdateTenantFuelTypeUseCase: 344,
  DeleteTenantFuelTypeUseCase: 345,
  AddDispatchNote: 347,
  SearchDispatchNotes: 348,
  FindDispatchNote: 349,
  UpdateDispatchNote: 350,
  DeleteDispatchNote: 351,
  BulkAddDispatchNote: 352,
  SearchWeightRouteOptimizations: 353,
  EffectiveWorkingHoursEveryPackageReport: 354,
  GetZobs: 355,
  GetDriversRanking: 356,
  ModifyIncidents: 357,
  VehicleUtilizationReport: 358,
  SearchWorkingHoursResetsUseCase: 359,
  FindWorkingHoursResetUseCase: 360,
  AddWorkingHoursResetUseCase: 361,
  UpdateWorkingHoursResetUseCase: 362,
  DeleteWorkingHoursResetUseCase: 363,
  TotalWorkingHoursReportSummaryUseCase: 364,
  TotalWorkingHoursReportUseCase: 365
}
